module.exports = __webpack_public_path__ + "src/assets/img/cutter.08218aa7.svg";